import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/Badge';
import { Button } from '@/components/Button';
import { OfferBudget } from '@/pages/Opportunities/OfferBudget';
import { OfferVersionForm } from '@/pages/Opportunities/OfferVersionForm';
import { moneyLabel } from '@/pages/Opportunities/dates';
import type { OfferVersion, OpportunityDetail } from '@/pages/Opportunities/types';

export interface OpportunityVersionsProps { item: OpportunityDetail; onSaved: (item: OpportunityDetail) => void; }
export const OpportunityVersions = ({ item, onSaved }: OpportunityVersionsProps) => {
    const { t, i18n } = useTranslation('global');
    const [create, setCreate] = useState(false);
    const [selected, setSelected] = useState<OfferVersion | null>(null);
    return <section className="space-y-4">
        <p className="text-sm">{t('opportunities.versions_explanation')}</p>
        {item.workflow_status === 'in_study' && !item.deleted_at && <Button icon="plus" onClick={() => setCreate(true)}>{t('opportunities.new_version')}</Button>}
        {item.versions.length === 0 && <p>{t('opportunities.no_versions')}</p>}
        {item.versions.map(version => <div key={version.id} className="space-y-2 rounded-xl border border-slate-200 p-4 dark:border-white/15">
            <div className="flex flex-wrap items-center justify-between gap-2"><span className="font-semibold">{version.number} · {version.name}</span><span>{moneyLabel(version.amount, item.currency_code, i18n.language)}</span></div>
            {version.submitted_at && <Badge variant="purple">{t('opportunities.version_presented')}</Badge>}
            {item.submitted_version_id === version.id && <Badge variant="success">{t('opportunities.current_presented')}</Badge>}
            <Button variant="outline" onClick={() => setSelected(selected?.id === version.id ? null : version)}>{t('opportunities.view_version')}</Button>
            {selected?.id === version.id && <div className="space-y-3">
                <p>{t('opportunities.snapshot_title')}: {String(version.snapshot.title ?? '')}</p>
                <p>{t('opportunities.fields.valuation_criteria')}: {String(version.snapshot.valuation_criteria ?? '')}</p>
                {version.bc3_data && <OfferBudget data={version.bc3_data} currency={item.currency_code} />}
                <details><summary className="cursor-pointer text-sm font-semibold">{t('opportunities.complete_snapshot')}</summary><pre className="max-h-96 overflow-auto whitespace-pre-wrap break-all text-xs">{JSON.stringify(version.snapshot, null, 2)}</pre></details>
            </div>}
        </div>)}
        {create && <OfferVersionForm item={item} onClose={() => setCreate(false)} onSaved={onSaved} />}
    </section>;
};
